




































import { Component, Prop, Vue } from 'vue-property-decorator';
import ICON_META from '@/constants/icon-meta.constant.json';

@Component
export default class QIconSelect extends Vue {
  @Prop() value?: string;

  search = '';
  dialog = false;

  get icons() {
    if (this.search) {
      const pattern = new RegExp(this.search, 'gi');
      return ICON_META.filter((meta) => meta.tags.some((tag) => tag.match(pattern)));
    } else {
      return ICON_META;
    }
  }

  get iconGroups() {
    const res: any = [[]];
    let counter = -1;
    for (let i = 0; i < this.icons.length; i++) {
      if (counter++ > 8) {
        res.push([]);
        counter = 0;
      }

      res[res.length - 1].push(this.icons[i]);
    }

    return res;
  }

  setIcon(iconName: string) {
    this.$emit('input', iconName);
    this.dialog = false;
  }
}
